import React, { Fragment } from "react";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import {  NavLink } from "react-router-dom";

const CareerPage = () => {

  const onClickHandler = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }
  return (
    <Fragment>
      <main className="page_content about-page ">
        <PageTitle pageTitle={"Career"} />
        <div className="pt-175 pb-80 ">
          <div className="heading_block text-center">
            <h2 className="heading_text mb-0">
              Available <mark>Jobs</mark> For You
            </h2>
          </div>
          <div className="container">
            <div className="row bg-light rounded p-4 mb-5">
              <div className="col-lg-12">
                <div className="career_block">
                  <h3 className="career_title">Search Engine Optimization Specialist</h3>
                  <p className="career_description">
                    We are committed to delivering high-quality travel experiences to our customers worldwide. With our rapidly growing online presence, we are looking for an experienced SEO Specialist to enhance our digital footprint and drive organic traffic to our platforms
                  </p>
                   <NavLink onClick={onClickHandler} to='/seo-detail' class="btn btn-primary">
                    <span class="btn_label" data-text="View Detail">
                      View Detail
                    </span>
                    <span class="btn_icon">
                      <i class="fa-solid fa-arrow-up-right"></i>
                    </span>
                  </NavLink>
                </div>
              </div>
            </div>
            <div className="row bg-light rounded p-4  mb-5">
              <div className="col-lg-12">
                <div className="career_block">
                  <h3 className="career_title">Graphic Designer</h3>
                  <p className="career_description">
                    We are seeking a creative, detail-oriented Graphic & Web Designer to join our team on a full-time, office-based basis. You’ll be responsible for designing posters, flyers, digital content, and website layouts that support our growing travel and events business.
                  </p>
                  <NavLink onClick={onClickHandler} to='/graphic-detail' class="btn btn-primary">
                    <span class="btn_label" data-text="View Detail">
                      View Detail
                    </span>
                    <span class="btn_icon">
                      <i class="fa-solid fa-arrow-up-right"></i>
                    </span>
                  </NavLink>
                </div>
              </div>
            </div>

             <div className="row bg-light rounded p-4  mb-5">
              <div className="col-lg-12">
                <div className="career_block">
                  <h3 className="career_title">Business Development Executive (Fresh to 2 Years Experience)</h3>
                  <p className="career_description">
                    We are looking for enthusiastic and career-driven Business Development Executives — fresh graduates and professionals with up to 2 years of experience — to join our dynamic sales team.
                  </p>
                  <NavLink onClick={onClickHandler} to='/bd-detail' class="btn btn-primary">
                    <span class="btn_label" data-text="View Detail">
                      View Detail
                    </span>
                    <span class="btn_icon">
                      <i class="fa-solid fa-arrow-up-right"></i>
                    </span>
                  </NavLink>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Scrollbar />
    </Fragment>
  );
};

export default CareerPage;
